import { useEffect, useState } from 'react';

function useJobs() {
    const [jobsLoading, setLoading] = useState();
    const [jobsData, setData] = useState({});
    const [jobsError, setError] = useState();

    const fetchJobs = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(`/sis/jobs`);
            if (res.ok) {
                const json = await res.json();
                setData(json);
            } else {
                setError(res.statusText);
            }
        } catch (error) {
            setError(error && error.message);
        }
        setLoading(false);
    }

    useEffect(() => {
        const timer = setInterval(() => fetchJobs(), 1000)
        return () => {
            clearInterval(timer);
        }
    }, [])

    return { jobsData, jobsError, jobsLoading };
}

export default useJobs
